import { FormElement, FormId } from "../../../../../components/enums";
import {
  FormSchema,
  ComplexFormSchemaComponents,
  SimpleFormSchemaComponents,
} from "../../../../../components/types";
import { selectCountry } from "../../../../../store/HOC/genericUI.selectors";
import { postalCodeMask } from "../../../../../utilities/masks";
import {
  selectIncidentWitnessesPersonsData,
  selectIncidentWitnessesData,
  selectIsWitnessesDataAvailable,
  selectUIData,
  selectCircumAvailableCities,
} from "../incident.selectors";
import {
  setAvailableCities,
  setIsWitnessesDataAvailable,
  setUIObjectField,
} from "../incident.slice";

import { ComponentId } from "./enums";

const multiplePersonForm = (
  id: string
): FormSchema<SimpleFormSchemaComponents> => ({
  id,
  formId: FormId.INCIDENT_WITNESSES,
  selector: selectIncidentWitnessesPersonsData,
  content: [
    {
      title: "Dane osoby",
      sections: [
        {
          id: ["persons-section-data-1", id].join("-"),
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              id: `persons[${id}][name]`,
              label: "Imię",
              required: true,
            },
            {
              type: FormElement.INPUT,
              id: `persons[${id}][surname]`,
              label: "Nazwisko",
              required: true,
            },
          ],
        },
        {
          id: ["persons-section-data-2", id].join("-"),
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.PHONE,
              country: selectCountry(selectUIData)(
                `witnessespersons${id}phone`
              ),
              id: `persons[${id}][phone]`,
              onChange: setUIObjectField,
              label: "Telefon",
              required: true,
            },
            {
              type: FormElement.INPUT,
              id: `persons[${id}][email]`,
              label: "Email",
            },
          ],
        },
      ],
    },
    {
      title: "Miejsce zamieszkania",
      sections: [
        {
          id: ["persons-section-address-data-1", id].join("-"),
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              id: `persons[${id}][street]`,
              label: "Ulica",
            },
            {
              type: FormElement.INPUT,
              id: `persons[${id}][street2]`,
              label: "Numer budynku / mieszkania",
            },
          ],
        },
        {
          id: ["persons-section-address-data-2", id].join("-"),
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.ZIP_CODE,
              mask: postalCodeMask,
              id: `persons[${id}][zipCode]`,
              label: "Kod pocztowy",
              // LPPLWEBMOB-728
              onChange: setAvailableCities,
            },
            {
              type: FormElement.SELECT_CITY,
              id: `persons[${id}][city]`,
              label: "Miejscowość",
              items: [],
              selectAvailableCities: selectCircumAvailableCities,
            },
          ],
        },
      ],
    },
  ],
});

export const form: FormSchema<
  ComplexFormSchemaComponents | SimpleFormSchemaComponents
> = {
  formId: FormId.INCIDENT_WITNESSES,
  selector: selectIncidentWitnessesData,
  content: [
    {
      title: "Świadkowie",
      sections: [
        {
          id: "incident-witnesses-data-1",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.RADIO,
              id: ComponentId.IS_WITNESSES_DATA_AVAILABLE,
              required: true,
              label: "Czy posiadasz dane świadków zdarzenia?",
              onChange: setIsWitnessesDataAvailable,
              items: [
                {
                  label: "tak",
                  value: "true",
                },
                {
                  label: "nie",
                  value: "false",
                },
              ],
            },
          ],
        },
        {
          id: "incident-witnesses-data-2",
          isVisible: selectIsWitnessesDataAvailable,
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.MULTIPLE_PERSON,
              id: ComponentId.PERSONS,
              form: multiplePersonForm,
            },
          ],
        },
      ],
    },
  ],
};
